export default "__VITE_ASSET__a0e04670__"